<template>
  <v-container id="users-tables" fluid tag="section">
    <base-material-card
      icon="mdi-clipboard-text"
      :title="pageTitle"
      class="px-5 py-3"
    >
      <v-data-table
        :headers="headers"
        :items="users"
        :page.sync="page"
        :loading="loading"
        loading-text="Đang tải... Vui lòng chờ"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat color="green">
            <v-text-field
              @input="debounceInput"
              append-icon="mdi-magnify"
              label="Tìm theo tên hoặc email"
              solo
              single-line
              hide-details
            ></v-text-field>
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Thêm người dùng
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row align="center" justify="center">
                      <v-avatar size="100" class="elevation-2">
                        <img
                          alt="Avatar"
                          :src="
                            editedUser.avatar || require('@/assets/face.jpg')
                          "
                        />
                      </v-avatar>
                    </v-row>
                    <v-text-field v-model="editedUser.name" label="Tên" />
                    <v-text-field
                      v-model="editedUser.email"
                      label="Email"
                      type="email"
                      :disabled="editedIndex !== -1"
                    />
                    <v-text-field
                      v-model="editedUser.age"
                      label="Tuổi"
                      type="number"
                    />
                    <v-select
                      v-model="editedUser.gender"
                      :items="genders"
                      label="Giới tính"
                    />
                    <v-text-field
                      v-if="editedIndex === -1"
                      v-model="editedUser.password"
                      type="password"
                      label="Mật khẩu"
                    />
                    <v-text-field :value="getRole" label="Vị trí" disabled />
                    <v-text-field
                      v-if="editedIndex !== -1"
                      :value="formatDate(editedUser.createdAt)"
                      label="Ngày tham gia"
                      :disabled="editedIndex !== -1"
                    />
                    <v-text-field
                      v-model="editedUser.description"
                      label="Mô tả"
                    />
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    :loading="loadingUpdate"
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.avatar`]="{ item }">
          <v-avatar size="36" class="elevation-2">
            <img
              alt="Avatar"
              :src="item.avatar || require('@/assets/face.jpg')"
            />
          </v-avatar>
        </template>
        <template v-slot:[`item.gender`]="{ item }">
          {{ getGender(item.gender) }}
        </template>
        <template v-slot:[`item.role`]="{}">
          {{ getRole }}
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2 info--text" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="error--text" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
        <template
          v-slot:[`item.conversations`]="{ item }"
          v-if="type == 'listener'"
        >
          <v-btn
            color="primary"
            x-small
            :href="`/admin/users/${item._id}/conversations`"
          >
            Trò chuyện
          </v-btn>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        class="mt-5"
        :circle="false"
        :disabled="false"
        :length="totalPages"
        next-icon="navigate_next"
        prev-icon="navigate_before"
        :page="page"
        :total-visible="totalPages"
        @input="goToPage"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import debounce from "debounce";
import UserApi from "@/api/UserApi";
export default {
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "Avatar",
          align: "start",
          sortable: false,
          value: "avatar"
        },
        { text: "Tên", value: "name" },
        { text: "Email", value: "email" },
        { text: "Tuổi", value: "age" },
        { text: "Giới tính", value: "gender" },
        { text: "Vai trò", value: "role" },
        { text: "Ngày tham gia", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "", value: "conversations", sortable: false }
      ],
      editedIndex: -1,
      editedUser: {
        avatar: "",
        name: "",
        email: "",
        role: this.$route.params.type,
        createdAt: "",
        description: "",
        gender: "F",
        age: 0,
        bookingPrice: 0
      },
      defaultUser: {
        avatar: "",
        name: "",
        email: "",
        role: this.$route.params.type,
        createdAt: "",
        description: "",
        gender: "F",
        age: 0,
        bookingPrice: 0
      },
      genders: [
        {
          text: "Nam",
          value: "M"
        },
        {
          text: "Nữ",
          value: "F"
        }
      ],
      page: 1,
      search: "",
      totalPages: 0,
      users: [],
      loading: true,
      loadingUpdate: false,
      type: this.$route.params.type
    };
  },
  computed: {
    pageTitle() {
      return {
        user: "Danh sách người dùng",
        listener: "Danh sách người lắng nghe",
        psychology: "Danh sách tham vấn viên"
      }[this.type];
    },
    formTitle() {
      return this.editedIndex === -1
        ? "Thêm người dùng"
        : "Chỉnh sửa thông tin";
    },
    getRole() {
      return {
        user: "Người dùng",
        listener: "Người lắng nghe",
        psychology: "Tham vấn viên"
      }[this.type];
    }
  },
  watch: {
    $route(to, from) {
      this.type = to.params.type;
      this.page = 1;
      this.loadData();
    }
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const response = await UserApi.getUsers(this.search, this.type);
      this.loading = false;
      const { ok, data, headers } = response;
      if (ok) {
        this.users = data;
        this.totalPages = parseInt(headers["x-total"], 10);
      }
    },
    getGender(gender) {
      return {
        M: "Nam",
        F: "Nữ"
      }[gender];
    },

    debounceInput: debounce(async function(search) {
      this.search = search;

      this.loading = true;
      const response = await UserApi.getUsers(search, this.type);
      this.loading = false;
      const { ok, data, headers } = response;
      if (ok) {
        this.users = data;
        this.totalPages = parseInt(headers["x-total"], 10);
        this.page = 1;
      }
    }, 500),

    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },

    async goToPage(page) {
      this.page = page;
      this.loading = true;
      const response = await UserApi.getUsers(this.search, this.type, page);
      this.loading = false;
      const { ok, data } = response;
      if (ok) {
        this.users = data;
      }
    },

    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedUser = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.users.indexOf(item);
      const agree = confirm("Bạn có chắc muốn xoá người dùng?");
      if (agree) {
        const res = await UserApi.deleteUser(item._id);
        if (res.ok) {
          this.users.splice(index, 1);
        } else {
          alert("Xoá người dùng không thành công");
        }
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedUser = Object.assign({}, this.defaultUser);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        const { name, age, gender, description } = this.editedUser;
        this.loadingUpdate = true;
        const res = await UserApi.update(this.editedUser._id, {
          name,
          age: parseInt(age, 10),
          gender,
          description
        });
        this.loadingUpdate = false;
        const { ok, data } = res;
        if (ok) {
          Object.assign(this.users[this.editedIndex], data);
        } else {
          alert("Cập nhật thông tin không thành công!");
        }
      } else {
        this.loadingUpdate = true;
        const res = await UserApi.create({
          ...this.editedUser,
          role: this.type,
          age: parseInt(this.editedUser.age, 10)
        });
        this.loadingUpdate = false;
        const { ok, data } = res;
        if (ok) {
          this.users.push(data);
        } else {
          alert("Tạo người dùng mới không thành công!");
        }
      }
      this.close();
    }
  }
};
</script>
